// initCompareStore.js

const STORAGE_KEY = 'pdr_compare_items';
const MINIMIZED_KEY = 'pdr_compare_minimized';
const MAX_ITEMS = 3;

// ==========================================
// AÇÕES EXPORTADAS (Para outros arquivos usarem)
// ==========================================

export function setWidgetMinimized(isMinimized) {
    localStorage.setItem(MINIMIZED_KEY, isMinimized ? 'true' : 'false');
}

export function getWidgetMinimized() {
    return localStorage.getItem(MINIMIZED_KEY) === 'true';
}

export function getCompareItems() {
    try {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
    } catch (e) {
        console.error('Erro ao ler localStorage do comparador', e);
        return [];
    }
}

export function dispatchUpdateEvent() {
    const currentItems = getCompareItems();
    const event = new CustomEvent('pdrCompareUpdated', {
        detail: { items: currentItems }
    });
    document.dispatchEvent(event);
}

export function addCompareItem(item) {
    const items = getCompareItems();

    if (items.length >= MAX_ITEMS) {
        console.warn('Limite de comparação atingido.');
        return false;
    }

    if (items.some(existingItem => String(existingItem.id) === String(item.id))) {
        return false;
    }

    items.push(item);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

    dispatchUpdateEvent();
    return true;
}

export function removeCompareItem(id) {
    let items = getCompareItems();
    const initialLength = items.length;

    items = items.filter(item => String(item.id) !== String(id));

    if (items.length !== initialLength) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        dispatchUpdateEvent();
    }
}

export function clearCompareItems() {
    localStorage.removeItem(STORAGE_KEY);
    dispatchUpdateEvent();
}

// ==========================================
// FUNÇÃO DE INICIALIZAÇÃO (Para o main.js)
// ==========================================

export default function initCompareStorage() {
    // Validação inicial silenciosa no DOMContentLoaded
    // Garante que o localStorage está íntegro e em formato de array
    const items = getCompareItems();
    if (!Array.isArray(items)) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify([]));
    }

    // Dispara o evento inicial para que o Widget saiba o estado logo que a página carrega
    dispatchUpdateEvent();
}